import $ from 'jquery';
import BaseComponent from 'wgnet-awesomejs/base/component';
import Application, {
    _
} from 'wgnet-awesomejs';

import { ERROR_BLOCK_EVENTS } from '../constants';
import { GTM_EVENT_TYPES } from '../fields/error';
import template from './template.html';

const ErrorBlock = BaseComponent.extend({
    name: 'error-block',
    parent: '.js-content',
    errorMessagePrefix: 'registration',
    template,
    initialize(...args) {
        BaseComponent.prototype.initialize.apply(this, args);
        this.dataLayer = window.dataLayer;
        if (this.data.messagePrefix) {
            this.errorMessagePrefix = this.data.messagePrefix;
        }
        this.parent = this.data.parent || this.parent;
        this.$parent = this.$el.parents(this.parent);

        Application.on(ERROR_BLOCK_EVENTS.show, _.bind(this.handleShowEvent, this));
        Application.on(ERROR_BLOCK_EVENTS.hide, _.bind(this.hideError, this));
    },
    handleShowEvent({ errorPrefix, errorSuffix, errors, errorsContext } = {}) {
        this.showErrors(null, { errorPrefix, errorSuffix, errors, errorsContext });
    },
    handleHideEvent() {
        this.hideError();
    },
    showErrors(event, result = {}) {
        const allowConflictCountryError = (window.Settings
            && window.Settings.Registration
            && window.Settings.Registration.fields
            && window.Settings.Registration.fields.country_code
            && window.Settings.Registration.fields.country_code.notification)
            ? window.Settings.Registration.fields.country_code.notification
            : false;
        const excludedErrors = [
            ...!allowConflictCountryError ? ['conflict_country'] : [],
            'not_found'
        ];
        const errors = result.errors || [];
        const error = _.extract(errors, '0.__all__', errors[0]);
        const prefix = result.errorPrefix && result.errorPrefix !== '__all__' ? `${result.errorPrefix}-` : '';
        const suffix = result.errorSuffix ? `-${result.errorSuffix}` : '';

        if (!error || excludedErrors.includes(error)) {
            return;
        }

        let errorContext = _.extract(result, `errorsContext.${error}`);
        if (!errorContext && result.errorPrefix === 'sms_code') {
            const smsCodeContext = _.extract(result, 'errorsContext.sms_code');
            if (smsCodeContext) {
                errorContext = smsCodeContext;
            }
        }

        let errorKey = `${this.errorMessagePrefix}-${prefix}${error}${suffix}`;
        let errorMsg = _.extract(`Settings.errors.${errorKey}`);
        if (!errorMsg) {
            errorKey = `${this.errorMessagePrefix}-${prefix}${error}`;
            errorMsg = _.extract(`Settings.errors.${errorKey}`);

            if (!errorMsg) {
                const defaultErrorKey = `${this.errorMessagePrefix}-no_connection`;

                errorMsg = _.extract(`Settings.errors.${defaultErrorKey}`);
            }
        }

        if (errorContext && errorContext.phone && errorContext.attempts) {
            const templateContext = {
                phone: errorContext.phone,
                attempts: errorContext.attempts,
            };
            errorMsg = errorMsg ? _.template(errorMsg)(templateContext) : errorMsg;
        } else if (errorContext && errorContext.codeLength) {
            errorMsg = errorMsg ?
                _.template(errorMsg)({ codeLength: errorContext.codeLength }) :
                errorMsg;
        } else if (errorContext) {
            errorMsg = errorMsg ? _.template(errorMsg)(errorContext) : errorMsg;
        }

        if (typeof this.dataLayer !== 'undefined') {
            this.dataLayer.push({
                event: 'GAevent',
                eventLabel: errorKey,
                eventCategory: 'Form messages',
                eventAction: GTM_EVENT_TYPES.error
            });
        }

        this.render({ error: errorMsg, type: result.warning ? 'warning' : 'error' });

        this.$el.find('.js-sms-resend-link-from-error').off('click').on('click', (e) => {
            e.preventDefault();
            const $form = this.$el.parent().find('.js-registration-form').first();
            if ($form.length) {
                const $link = $form.find('.js-sms-resend-link').first();
                if ($link.length) {
                    $link.trigger('click');
                }
            }
        });

        if (error === 'empty_field') {
            const firstEmpty = _.find(this.$parent.find('.js-form input:visible'), input => !input.value);
            if (firstEmpty) {
                $(firstEmpty).focus();
            }
        }

        if (error === 'conflict_country') {
            $('.js-country_code-dropdown-menu_item').on('click', () => {
                this.hideError();
            });
        }
    },
    hideError() {
        this.render();
    }
});

export default ErrorBlock;



// WEBPACK FOOTER //
// ./registration/static_source/js/registration/base/error_block/index.js